export default "__VITE_ASSET__CqXSH9kY__"